import { reactToCwp } from '../../../common/react-utils'
import { MicrositeContact } from './MicrositeContact'

export default reactToCwp(MicrositeContact)
